import angular from 'angular';
import SMSTemplates from './smsTemplates';
import SMSTemplatesSelection from './smsTemplatesSelection/smsTemplatesSelection';
import mergeFieldSelection from '../mergeFieldsSelection';

export default angular
  .module('components.smsTemplates', [mergeFieldSelection])
  .component('smsTemplates', SMSTemplates)
  .component('smsTemplatesSelection', SMSTemplatesSelection).name;
